import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrlWithPathVariable, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    content: data?.content?.map((item: any) => ({
      id: `${item?.id ?? ''}`,
      entityId: item?.entityId,
      entityID: item?.entityId,
      scheme: item?.scheme,
      cardType: item?.cardType,
      status: item?.status,
    })),
  }
}

const getCardByEntity = (id: any, reqBody: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrlWithPathVariable(APIEndPoints.cardMappingByEntity, id),
    method: 'POST',
    cache: false,
    body: reqBody,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getCardByEntity }
